import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import {Label} from '../label';
// searchString and value is used by nested Dropdown
// eslint-disable-next-line no-unused-vars
export const LabelLine = ({name, color, searchString, value}) => {
	return (
		<Container>
			<Label name={name} color={color} />
		</Container>
	);
};

export const Container = Styled.div`
	background-color: transparent;
	padding: 5px 0;
`;

LabelLine.propTypes = {
	name: PropTypes.string,
	color: PropTypes.string,
	searchString: PropTypes.string.isRequired,
	value: PropTypes.any,
};
